var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_user_review'] = require('../../user_review.html.mustache');

ProductReviews.Views.ReviewCard = require('./product_reviews_review_card');

ProductReviews.Views.ReviewRating = require('./product_reviews_review_rating');

ProductReviews.Views.UserReview = Backbone.View.extend({
  render: function() {
    this.$el.find('.product-reviews-form-extension').after(ProductReviews.Templates['product_reviews_user_review'].render({
      userReview: this.model.attributes
    }));
    (new ProductReviews.Views.ReviewCard({
      model: this.model,
      el: this.$el.selector + " .user-review-card"
    })).render();
    return (new ProductReviews.Views.ReviewRating({
      model: this.model,
      el: this.$el.selector + " .user-review-card .review-rating"
    })).render();
  }
});

module.exports = ProductReviews.Views.UserReview;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvdmlld3MvcHJvZHVjdF9yZXZpZXdzX3VzZXJfcmV2aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvcHJvZHVjdF9yZXZpZXdzL2Zyb250ZW5kL3ZpZXdzL3Byb2R1Y3RfcmV2aWV3c191c2VyX3Jldmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxjQUFBLG1DQUFpQixNQUFNLENBQUMsaUJBQVAsTUFBTSxDQUFDLGlCQUFrQjs7O0VBQzFDLGNBQWMsQ0FBQyxRQUFTOzs7O0VBQ3hCLGNBQWMsQ0FBQyxZQUFhOzs7QUFFNUIsY0FBYyxDQUFDLFNBQVUsQ0FBQSw2QkFBQSxDQUF6QixHQUEwRCxPQUFBLENBQVEsaUNBQVI7O0FBQzFELGNBQWMsQ0FBQyxLQUFLLENBQUMsVUFBckIsR0FBa0MsT0FBQSxDQUFRLCtCQUFSOztBQUNsQyxjQUFjLENBQUMsS0FBSyxDQUFDLFlBQXJCLEdBQW9DLE9BQUEsQ0FBUSxpQ0FBUjs7QUFFcEMsY0FBYyxDQUFDLEtBQUssQ0FBQyxVQUFyQixHQUFrQyxRQUFRLENBQUMsSUFBSSxDQUFDLE1BQWQsQ0FDaEM7RUFBQSxNQUFBLEVBQVEsU0FBQTtJQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLGlDQUFWLENBQTRDLENBQUMsS0FBN0MsQ0FBbUQsY0FBYyxDQUFDLFNBQVUsQ0FBQSw2QkFBQSxDQUE4QixDQUFDLE1BQXhELENBQStEO01BQUEsVUFBQSxFQUFZLElBQUMsQ0FBQSxLQUFLLENBQUMsVUFBbkI7S0FBL0QsQ0FBbkQ7SUFDQSxDQUFDLElBQUksY0FBYyxDQUFDLEtBQUssQ0FBQyxVQUF6QixDQUFvQztNQUFBLEtBQUEsRUFBTyxJQUFDLENBQUEsS0FBUjtNQUFlLEVBQUEsRUFBTyxJQUFDLENBQUEsR0FBRyxDQUFDLFFBQU4sR0FBZSxvQkFBcEM7S0FBcEMsQ0FBRCxDQUE2RixDQUFDLE1BQTlGLENBQUE7V0FDQSxDQUFDLElBQUksY0FBYyxDQUFDLEtBQUssQ0FBQyxZQUF6QixDQUFzQztNQUFBLEtBQUEsRUFBTyxJQUFDLENBQUEsS0FBUjtNQUFlLEVBQUEsRUFBTyxJQUFDLENBQUEsR0FBRyxDQUFDLFFBQU4sR0FBZSxtQ0FBcEM7S0FBdEMsQ0FBRCxDQUE4RyxDQUFDLE1BQS9HLENBQUE7RUFITSxDQUFSO0NBRGdDOztBQU9sQyxNQUFNLENBQUMsT0FBUCxHQUFpQixjQUFjLENBQUMsS0FBSyxDQUFDIn0=
